import { Link } from "react-router-dom";
import { ShieldCheck, Lock, Zap, Globe } from "lucide-react";

export const SEOContentSection = () => {
  return (
    <section className="py-16 md:py-20 bg-secondary/20 overflow-hidden">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="font-serifAccent text-3xl md:text-4xl text-foreground tracking-tight mb-3">
            Private PDF Processing
          </h2>
          <p className="text-text-secondary max-w-2xl mx-auto">
            <strong className="text-foreground">PDFWorkSpace</strong> runs
            entirely in your browser using{" "}
            <a
              href="https://mozilla.github.io/pdf.js/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-foreground hover:underline"
            >
              WebAssembly
            </a>
            . Your files never leave your device.
          </p>
        </div>

        {/* Feature Grid */}
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4 mb-12">
          <div className="rounded-xl border border-border bg-card p-5 text-center transition-colors hover:border-foreground/30">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-gray-500/10 text-gray-500 mb-4">
              <ShieldCheck className="w-6 h-6" />
            </div>
            <h3 className="font-semibold text-foreground mb-1">No Uploads</h3>
            <p className="text-sm text-text-secondary">
              100% client-side. Zero data sent to servers.
            </p>
          </div>

          <div className="rounded-xl border border-border bg-card p-5 text-center transition-colors hover:border-foreground/30">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-gray-500/10 text-gray-500 mb-4">
              <Zap className="w-6 h-6" />
            </div>
            <h3 className="font-semibold text-foreground mb-1">
              Instant Processing
            </h3>
            <p className="text-sm text-text-secondary">
              WASM-powered for desktop-class speed.
            </p>
          </div>

          <div className="rounded-xl border border-border bg-card p-5 text-center transition-colors hover:border-foreground/30">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-gray-500/10 text-gray-500 mb-4">
              <Lock className="w-6 h-6" />
            </div>
            <h3 className="font-semibold text-foreground mb-1">
              Zero Knowledge
            </h3>
            <p className="text-sm text-text-secondary">
              No tracking, no analytics, no accounts.
            </p>
          </div>

          <div className="rounded-xl border border-border bg-card p-5 text-center transition-colors hover:border-foreground/30">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-gray-500/10 text-gray-500 mb-4">
              <Globe className="w-6 h-6" />
            </div>
            <h3 className="font-semibold text-foreground mb-1">
              Works Offline
            </h3>
            <p className="text-sm text-text-secondary">
              Full functionality without internet.
            </p>
          </div>
        </div>

        {/* Tool Links (for SEO) */}
        <div className="text-center">
          <p className="text-sm text-text-secondary mb-4">Popular tools:</p>
          <div className="flex flex-wrap justify-center gap-2">
            <Link
              to="/tools/merge"
              className="px-4 py-2 rounded-full border border-border bg-card text-sm text-text-secondary hover:text-foreground hover:border-foreground/40 transition-colors"
            >
              Merge PDFs
            </Link>
            <Link
              to="/tools/compress"
              className="px-4 py-2 rounded-full border border-border bg-card text-sm text-text-secondary hover:text-foreground hover:border-foreground/40 transition-colors"
            >
              Compress
            </Link>
            <Link
              to="/tools/edit-pdf"
              className="px-4 py-2 rounded-full border border-border bg-card text-sm text-text-secondary hover:text-foreground hover:border-foreground/40 transition-colors"
            >
              Edit & Sign
            </Link>
            <Link
              to="/tools/ocr-pdf"
              className="px-4 py-2 rounded-full border border-border bg-card text-sm text-text-secondary hover:text-foreground hover:border-foreground/40 transition-colors"
            >
              OCR
            </Link>
            <Link
              to="/tools/security/encrypt-pdf"
              className="px-4 py-2 rounded-full border border-border bg-card text-sm text-text-secondary hover:text-foreground hover:border-foreground/40 transition-colors"
            >
              Encrypt
            </Link>
            <Link
              to="/tools/organize-pdf"
              className="px-4 py-2 rounded-full border border-border bg-card text-sm text-text-secondary hover:text-foreground hover:border-foreground/40 transition-colors"
            >
              Organize Pages
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
